import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    userExamSelectQuestion, userExamFlagQuestion, userExamFavQuestion, userGetExamQuestions,
    userExamAnswerQuestion, userOnFinishExam, userExamInfoChanged, userExamHideSomeAnswers,
    userExamExcludeOption, userFilterExamQuestions, userHighlightTextQuestion, userSeeExamQuestions
} from '../../actions';
import { Spinner, ErrorSegment } from '..';
import Results from './ExamResults';
import ExamLayout from './ExamBody/Layout';

const Exam = (props) => {

    const { loading, error, Q, questions: allQuestions, questionOptionsLoading, questionOptionsError,
        onGoingExam, userGetExamQuestions, userExamSelectQuestion, userExamFlagQuestion, userExamFavQuestion,
        userExamAnswerQuestion, userOnFinishExam, userExamInfoChanged, isFinished, examFinishingLoading,
        selectedCourse, selectedCourseStruct, user, userExamHideSomeAnswers, userExamExcludeOption, nextSibsFinished,
        questionsFilter, userFilterExamQuestions, filteredQuestions: questions, userHighlightTextQuestion, userSeeExamQuestions,
        BankResults
    } = props;

    const [showExamSummary, setShowExamSummary] = useState(false);


    const handleQuestionFilterChange = (filter) => {
        setShowExamSummary(false);
        const filterQuestions = structuredClone(filter === "FLAGGED" ? allQuestions.filter(q => q.isFlagged) : filter === "UNATTEMPTED" ? allQuestions.filter(q => !(q?.answerOptionId || q?.answerText || q?.answerJson)) : allQuestions);
        userExamSelectQuestion(filterQuestions[0]);
        userFilterExamQuestions(filter);
    };

    useEffect(() => {
        const zsalesiq = document.querySelector('[data-id="zsalesiq"]');
        if (zsalesiq) zsalesiq.style.visibility = 'hidden';
        window.onbeforeunload = () => 'confirm';
        onGoingExam?.examRoundId && userGetExamQuestions(onGoingExam.examRoundId, onGoingExam);

        return () => {
            // just for mock special case
            userExamInfoChanged({ props: 'questions', value: [] });
            userExamInfoChanged({ props: 'filteredQuestions', value: [] });
            userExamInfoChanged({ props: 'Q', value: null });
            userExamInfoChanged({ props: 'examFinishingLoading', value: false });
            window.onbeforeunload = () => undefined;
            if (zsalesiq) zsalesiq.style.visibility = 'visible';
        };
        //eslint-disable-next-line
    }, [onGoingExam?.examType, onGoingExam?.id]);

    // Once the exam is finished there is nothing left to lose: leaving its
    // result must not ask "leave site?" as leaving a running exam does.
    useEffect(() => {
        window.onbeforeunload = isFinished ? () => undefined : () => 'confirm';
    }, [isFinished]);

    if (loading || !allQuestions.length) return <Spinner />;
    if (error) return <ErrorSegment />;
    if (isFinished) return <Results onGoingExam={onGoingExam} nextSibsFinished={nextSibsFinished} summary={{ show: showExamSummary, setShowSummary: setShowExamSummary }} BankResults={BankResults} />;

    const Qindex = Q ? questions.findIndex(q => q.questionId === Q.questionId) : null;
    const facts = [];
    for (let q of questions)
        if (q.factId) facts.push(q.factId);
    const FactIndex = Q ? [...new Set(facts)].findIndex(q => q === Q.factId) : null;

    return (
        // <NoCopyPaste theme={onGoingExam.theme}>

        <ExamLayout
            selectedCourse={selectedCourse}
            selectedCourseStruct={selectedCourseStruct}
            Qindex={Qindex}
            Q={Q}
            user={user}
            questions={questions}
            onGoingExam={onGoingExam}
            userOnFinishExam={userOnFinishExam}
            examFinishingLoading={examFinishingLoading}
            showExamSummary={showExamSummary}
            setShowExamSummary={setShowExamSummary}
            userExamSelectQuestion={userExamSelectQuestion}
            handleQuestionFilterChange={handleQuestionFilterChange}
            questionsFilter={questionsFilter}
            FactIndex={FactIndex}
            questionOptionsLoading={questionOptionsLoading}
            questionOptionsError={questionOptionsError}
            userExamFlagQuestion={userExamFlagQuestion}
            userExamFavQuestion={userExamFavQuestion}
            userExamAnswerQuestion={userExamAnswerQuestion}
            userExamHideSomeAnswers={userExamHideSomeAnswers}
            userExamExcludeOption={userExamExcludeOption}
            userExamHighlightText={userHighlightTextQuestion}
            userSeeExamQuestions={userSeeExamQuestions}
            theme={onGoingExam.theme}
        />


        // </NoCopyPaste>
    );
};


const mapStateToProps = ({ userExam, userCourses, auth }) => {
    const { loading, error, questions, Q, questionOptionsLoading, questionOptionsError,
        isFinished, examFinishingLoading, nextSibsFinished, filteredQuestions, questionsFilter } = userExam;
    const { selectedCourse, selectedCourseStruct } = userCourses;
    const { user } = auth;
    return {
        loading, error, questions, Q, questionOptionsLoading, questionOptionsError,
        isFinished, nextSibsFinished, examFinishingLoading, selectedCourse,
        selectedCourseStruct, user, filteredQuestions, questionsFilter
    };
};

export default connect(mapStateToProps, {
    userGetExamQuestions, userExamSelectQuestion,
    userExamFlagQuestion, userExamFavQuestion, userExamAnswerQuestion, userOnFinishExam,
    userExamInfoChanged, userExamHideSomeAnswers, userExamExcludeOption, userFilterExamQuestions,
    userHighlightTextQuestion, userSeeExamQuestions
})(Exam);
